import type * as Types from '../types.generated';

import { gql } from '@oneaudi/onegraph-client';
import type * as Apollo from '@apollo/client';
export type ChangeConfiguredCarFeatureQueryVariables = Types.Exact<{
  changeConfiguredCarFeatureInput: Types.ChangeConfiguredCarFeatureInput;
}>;

export type ChangeConfiguredCarFeatureQuery = { __typename?: 'Query' } & {
  changeConfiguredCarFeature: { __typename?: 'ChangeConfiguredCarPayload' } & {
    configuredCar?: Types.Maybe<
      { __typename?: 'ConfiguredCar' } & Pick<Types.ConfiguredCar, 'idString'> & {
          id: { __typename?: 'ConfiguredCarIdentifier' } & Pick<
            Types.ConfiguredCarIdentifier,
            'exteriorColor' | 'interiorColor' | 'salesGroup' | 'equipmentOptions'
          > & {
              model: { __typename?: 'ConfiguredCarModelIdentifier' } & Pick<
                Types.ConfiguredCarModelIdentifier,
                'code' | 'version' | 'year' | 'extensions'
              >;
            };
          media?: Types.Maybe<
            { __typename?: 'ConfiguredCarMediaResources' } & {
              images: Array<
                { __typename?: 'RenderedCarImage' } & Pick<
                  Types.RenderedCarImage,
                  'url' | 'profileId' | 'altTextMetaKeys'
                >
              >;
              ave?: Types.Maybe<
                { __typename?: 'ConfiguredCarAve' } & Pick<Types.ConfiguredCarAve, 'renderString'>
              >;
            }
          >;
        }
    >;
  };
};

export const ChangeConfiguredCarFeatureDocument = gql`
  query ChangeConfiguredCarFeature(
    $changeConfiguredCarFeatureInput: ChangeConfiguredCarFeatureInput!
  ) {
    changeConfiguredCarFeature(input: $changeConfiguredCarFeatureInput) {
      configuredCar {
        idString
        id {
          model {
            code
            version
            year
            extensions
          }
          exteriorColor
          interiorColor
          salesGroup
          equipmentOptions
        }
        media {
          images(
            filterInput: {
              filterByProfileId: [
                "EXTERIOR-FRONT-3-4"
                "EXTERIOR-FRONT-3-4-ENV1"
                "EXTERIOR-FRONT-FRONT"
                "EXTERIOR-FRONT-FRONT-ENV1"
                "EXTERIOR-REAR-3-4"
                "EXTERIOR-REAR-3-4-ENV1"
                "EXTERIOR-PARALLEL-SIDE"
                "EXTERIOR-PARALLEL-SIDE-ENV1"
                "EXTERIOR-WHEELS-RIM"
                "EXTERIOR-WHEELS-RIM-ENV1"
                "INTERIOR-DASHBOARD-DASHBOARD"
                "INTERIOR-DASHBOARD-DASHBOARD-ENV1"
                "custfront"
                "custside"
                "cust34front"
                "cust34rear"
              ]
            }
          ) {
            url
            profileId
            altTextMetaKeys
          }
          ave {
            renderString
          }
        }
      }
    }
  }
`;
export type ChangeConfiguredCarFeatureQueryResult = Apollo.QueryResult<
  ChangeConfiguredCarFeatureQuery,
  ChangeConfiguredCarFeatureQueryVariables
>;
